import { z } from 'zod';

export const setValueInputSchema = z.object({
  entryId: z.string().min(1, 'entryId is required'),
  fieldId: z.string().min(1, 'fieldId is required'),
  // Full value shape validation runs after ValueSdk adds SDK-generated item IDs.
  value: z.unknown().refine((value) => value !== undefined, {
    message: 'value is required',
  }),
  resetValue: z.boolean().optional(),
});

export const clearValueSchema = z.object({
  entryId: z.string().min(1, 'entryId is required'),
  fieldId: z.string().min(1, 'fieldId is required'),
});

export type SetValueInput = z.infer<typeof setValueInputSchema>;
export type ClearValueInput = z.infer<typeof clearValueSchema>;
